import React from "react"

import { ProductConfiguratorAddonOptionProps } from "shared/types/ProductConfigurator"

import { ProductConfiguratorOptionRenderer } from "../ProductConfiguratorOptionRenderer"

function ProductConfiguratorAddonOptionRendererComponent(
  props: ProductConfiguratorAddonOptionProps
) {
  // Selecting an addon is the toggle's job, so the card only expands/collapses.
  return (
    <ProductConfiguratorOptionRenderer
      {...props}
      onSelect={undefined}
      canSwipeToDelete={false}
    />
  )
}

export const ProductConfiguratorAddonOptionRenderer = React.memo(
  ProductConfiguratorAddonOptionRendererComponent
) as typeof ProductConfiguratorAddonOptionRendererComponent
